// ;(function(/* BrowserSync-Brunch */) {
//   var url = "//" + location.hostname + ":3000/browser-sync/browser-sync-client.2.1.6.js";
//   var bs = document.createElement("script");
//   bs.type = "text/javascript"; bs.async = true; bs.src = url;
//   var s = document.getElementsByTagName("script")[0];
//   s.parentNode.insertBefore(bs, s);
// })();

var timerArtist = false;

$(document).ready(function(){
	
	init() ; 

	// Barba JS transition
	Barba.Pjax.start();
	var FadeTransition = Barba.BaseTransition.extend({
		start: function() {
		// As soon the loading is finished and the old page is faded out, let's fade the new page
		Promise
		  .all([this.newContainerLoading, this.fadeOut()])
		  .then(this.fadeIn.bind(this));
		},

		fadeOut: function() {
			var deferred = Barba.Utils.deferred();
			TweenLite.to($(this.oldContainer), 0.3, {
				autoAlpha:0,
				onComplete:(function(){
					window.scrollTo(0,0);
					deferred.resolve();
				})
			}) ;
			return deferred.promise;
		},

		fadeIn: function() {

			var _this = this;
			var $el = $(this.newContainer);
			var deferred = Barba.Utils.deferred();

			$(this.oldContainer).hide();

			$el.css({
			  visibility : 'visible',
			  opacity : 0,
			});

			TweenLite.to($el, 0.3, {
				autoAlpha:1,
				onComplete:(function(){
					_this.done();
					init();
				})
			}) ;
		}
	});
	Barba.Pjax.getTransition = function() {
		return FadeTransition;
	};
});

function init() {
	console.log('init');

	// Mobile Menu Manager
	$('.cta-menu').click(function(){
		TweenLite.to($('.nav-mobile'), 0.5, {autoAlpha:1, ease:Expo.easeOut}) ; 
	}) ; 
	$('.cta-close').click(function(){
		TweenLite.to($('.nav-mobile'), 0.5, {autoAlpha:0, ease:Expo.easeOut});
	}) ; 	

	// Home tour date block : safari fix
	if(!$('.cta-menu').is(':visible')) {
		$('.tourdate-first').height($('#home-tourdates .td-container').height()) ; 
		$(window).resize(function(){
			// Resize first TD
			$('.tourdate-first').height($('#home-tourdates .other-tourdates').height()) ;
		})
	}

	
	

	// Home Slider init
	$('.slider-container').slick({
		arrows : true,
		dots : true,
		adaptiveHeight: false,
		pauseOnHover: false,
		pauseOnDotsHover: true,
		autoplay: true,
		autoplaySpeed: 5000,
		lazyLoad: 'ondemand',
		prevArrow: '<span class="control prev"><i class="icon icon-arrow-left"></i></span>',
		nextArrow: '<span class="control next"><i class="icon icon-arrow-right"></i></span>',
	});

	// Artist mini gallery slider init
	$('.artist-galerie .gallery-list').slick({
		arrows : true,
		dots : false,
		slidesToShow: 3,
		adaptiveHeight: false,
		pauseOnHover: false,
		pauseOnDotsHover: true,
		prevArrow: '<span class="control prev"><i class="icon icon-arrow-left"></i></span>',
		nextArrow: '<span class="control next"><i class="icon icon-arrow-right"></i></span>',
	});

	// Artist full gallery slider init
	$('.gallery-list .slick-slide').click(function(){
		$('.gallery-full .gallery-full-list').slick({
			arrows : true,
			dots : true,
			adaptiveHeight: false,
			pauseOnHover: false,
			pauseOnDotsHover: true,
			initialSlide: Math.round(Math.abs($(this).attr('data-slick-index')) % ($('.gallery-list .slick-slide').length / 3)),
			prevArrow: '<span class="control prev"><i class="icon icon-arrow-left"></i></span>',
			nextArrow: '<span class="control next"><i class="icon icon-arrow-right"></i></span>',
		});
		TweenLite.to($('.gallery-full'), 0.5, {autoAlpha:1, ease:Expo.easeOut});
	});

	// Close gallery full on click
	$('.gallery-full').click(function() {
		TweenLite.to($('.gallery-full'), 0.5, {
			autoAlpha:0,
			ease:Expo.easeOut,
			onComplete:(function(){
				$('.gallery-full .gallery-full-list').slick('unslick');
			})
		});
	})
	$('.gallery-full .gallery-full-list').click(function(ev){
		ev.stopPropagation();
		ev.preventDefault();
	})

	// Artist hover effect
	if(!$('.cta-menu').is(':visible')) {
		$('.list-artists').mouseenter(function(){
			$(this).addClass('active');
		});
		$('.list-artists .artist-title').mouseenter(function(){
			
			var imgSrc = $(this).siblings('.artist-img').attr('data-img');
			var tlHideArtist = new TimelineLite({paused:true});
			tlHideArtist.add('start');
			tlHideArtist.fromTo($('.artists-container .overlay'), 0.3, {autoAlpha:0.5}, {autoAlpha:1, ease:Quad.easeOut, onComplete: preloadBckImg, onCompleteParams: [imgSrc]});
			tlHideArtist.play();
			
		});

		$('.list-artists .artist-title').mouseout(function(){
			var tlSwitchArtist = new TimelineLite({paused:true});
			tlSwitchArtist.add("start")
			tlSwitchArtist.to($('.artists-container .overlay'), 0.3, {autoAlpha:1, ease:Quad.easeOut});
			tlSwitchArtist.play()
		});
	}
}

function preloadBckImg(src) {
	var img = new Image();
	img.onload = function() {
		$('.artists-container .img-container').css('background-image', 'url("' + this.src + '")');
		var tlShowArtist = new TimelineLite({paused:true});
		tlShowArtist.add('start');
		tlShowArtist.fromTo($('.artists-container .overlay'), 0.3, {autoAlpha:1}, {autoAlpha:0.5, ease:Quad.easeOut}, 'start+=0.2');
		tlShowArtist.play();
	};
	img.src = src ;
}